/* TEST — redzam QuickAdd modāli un swatchu skaitu */
new MutationObserver(muts => {
  muts.forEach(m => m.addedNodes.forEach(node => {
    if (node.nodeType === 1 && node.id && node.id.startsWith('QuickAdd-')) {
      console.log('%c[QV-SYNC] Atradu QuickAdd modāli:', 'color:#31A3FF', node);
      console.log('[QV-SYNC] Swatchu skaits:',
                  node.querySelectorAll('.swatch').length);
    }
  }));
}).observe(document.body, { childList:true, subtree:true });







document.addEventListener('modal:open', ({ target: modal }) => attach(modal));

function attach(modal){
  /* notinam, ja klausītāji jau ir pieslēgti */
  if(modal.dataset.synced) return;
  modal.dataset.synced = 'yes';

  /* pirmo reizi, un tad – pēc katras variant maiņas */
  init(modal);

  modal.addEventListener('variant:changed', () => init(modal), { capture:true });
}

/* piesaitām klausītājus dotajam HTML “snapshotam” */
function init(scope){
  const select = scope.querySelector('select[name="id"]');
  const info   = scope.querySelector('.inventory-info');
  const qty    = scope.querySelector('.inventory-quantity');
  const color  = scope.querySelector('.inventory-color');

  /* ja nav swatchu (piem., produktam tikai 1 variants) – beidzam */
  const swatches = scope.querySelectorAll('.swatch');
  if(!swatches.length) return;

  /* atsvaidzini aktīvo rāmi */
  swatches.forEach(s => s.classList.toggle(
      'active',
      s.dataset.variantId === select.value
  ));

  /* swatch → dropdown (bez value maiņas) */
  swatches.forEach(s => {
    s.onclick = () => {
      swatches.forEach(el => el.classList.remove('active'));
      s.classList.add('active');

      color.textContent = select.options[select.selectedIndex].text.trim();
      qty.textContent   = s.querySelector('.swatch-inventory').textContent.trim();
    };
  });

  /* dropdown → swatch + info */
  select.onchange = () => {
    const target = scope.querySelector(`.swatch[data-variant-id="${select.value}"]`);
    if(target){
      target.onclick();                // “imitējam” klikšķi bez value maiņas
    }
  };

  /* pirmreizēji atjaunojam info */
  select.onchange();
}
